(function () {
    'use strict';

    qbPremiumBreakdownController.$inject = ['$scope', '$window', '$rootScope', '$filter', 'labelService'];
    
    function qbPremiumBreakdownController($scope, $window, $rootScope, $filter, labelService) {
        var vm = this;

        vm.lookupLabel = function (fieldName) {
            return labelService.getGlobalOptionLabel('paymentSummary', fieldName);
        };
    }

    angular.module('qbePortal').component('qbPremiumBreakdown', {
        templateUrl: '/ngviews/components/qbPremiumBreakdown.html',
        controller: qbPremiumBreakdownController,
        controllerAs: 'vm',
        bindings: {
            paymentFrequency: '@',
            quoteResults: '=',
            monthlyResults: '='
        },
    });

})();